<template>
  <div class="row">
    <div v-if="isLoading" class="col-lg-12">
      <Loader size="lg"></Loader>
    </div>
    <div v-else class="col-lg-12">
      <div>
        <div class="card-body">
          <template v-if="retrieved">
            <b-row>
              <b-col class="form-group">
                <label class="form-control-label">{{$t('views.excmtask.show.deadlineDate')}}:</label><br>
                <el-date-picker
                  :picker-options="{firstDayOfWeek: 1}"
                  v-model="deadlineDate"
                  type="datetime"
                  default-time="12:00:00">
                </el-date-picker>
              </b-col>
            </b-row>
            <b-row v-if="retrieved.customFields.length > 0">
              <b-col>
                <div v-for="(customField, index) in retrieved.customFields" v-bind:key="'customField-' + index">
                  <TaskCustomFields :item="customField"></TaskCustomFields>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <button
                  @click="onSendForm()"
                  type="submit"
                  class="btn btn-success">{{$t('buttons.submit')}}</button>
                <button v-if="retrieved.finished === 0"
                  @click="onSendForm(true)"
                  type="submit"
                  class="btn btn-success">{{$t('buttons.submitAndCloseTask')}}</button>
                <button
                  v-if="ableToCreateTask && retrieved.finished === 0"
                  @click="onSendForm(false, true)"
                  type="submit"
                  class="btn btn-success">{{$t('buttons.submitAndCreateNew')}}</button>
                <button
                  @click="closeModal()"
                  type="submit"
                  class="btn btn-warning">{{$t('buttons.cancel')}}</button>
              </b-col>
            </b-row>
          </template>
        </div>
      </div>
    </div>
    <create-task-modal @modalHidden="selectedItem = '';closeModal()" v-if="selectedItem && $route.name !== 'EXCMTaskShow'" :id-case="selectedItem"></create-task-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import TaskCustomFields from '@/components/Dashboard/Views/excmtask/components/TaskCustomFields'
import Loader from '@/components/Dashboard/Layout/Loader'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'

export default {
  components: {
    Loader,
    TaskCustomFields,
    CreateTaskModal
  },

  data () {
    return {
      prevRoute: null,
      item: {},
      routeName: '',
      idCase: '',
      deadlineDate: '',
      selectedItem: ''
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmtask/update/isLoading',
      error: 'excmtask/update/error',
      retrieved: 'excmtask/update/retrieved',
      updated: 'excmtask/update/updated'
    }),
    ableToCreateTask () {
      return checkPermission('tasks', 'EXCMTaskCreate')
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeCreate () {
    checkPagePermission('tasks', 'EXCMTaskUpdate')
  },

  watch: {
    retrieved () {
      if (this.retrieved && this.retrieved.idCase) {
        if (this.retrieved.idCase['@id']) {
          this.idCase = this.retrieved.idCase['@id']
        } else {
          this.idCase = this.retrieved.idCase
        }
        this.deadlineDate = this.retrieved.deadlineDate
      }
    },
    updated () {
      if (this.prevRoute) {
        this.$router.push(this.prevRoute)
      } else {
        if (!this.selectedItem) {
          this.$store.state.modals.updateTaskParams.close = 1
        }
        this.$emit('reload')
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    this.retrieve(decodeURIComponent(this.$store.state.modals.updateTaskParams.path))
  },
  methods: {
    ...mapActions({
      createReset: 'excmtask/create/reset',
      retrieve: 'excmtask/update/retrieve',
      updateReset: 'excmtask/update/reset',
      update: 'excmtask/update/update',
      updateRetrieved: 'excmtask/update/updateRetrieved'
    }),
    ...mapMutations({
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal'
    }),
    reset () {
      this.updateReset()
      this.createReset()
    },

    closeModal () {
      this.$store.state.modals.updateTaskParams.close = 1
    },
    addTask () {
      this.selectedItem = this.idCase
      this.toggleCreateTaskModal()
    },

    onSendForm (withClose = false, withCreateNext = false) {
      this.$store.state.excmtask.update.retrieved = { '@id': this.retrieved['@id'], customFields: this.retrieved.customFields, deadlineDate: this.$moment(this.deadlineDate).format('YYYY-MM-DD HH:mm') }
      this.update({ withClose: withClose, withCreateNext: withCreateNext, closeCallback: () => this.$router.push({ name: 'EXCMCaseShow', params: { id: this.idCase } }), createNextCallback: () => this.addTask() })
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
